import React from 'react';

import { FieldProps } from 'formik';

import FormInputWithButton from './FormInputWithButton';

type Props = {
    name: string;
    mapNameToLabel: (name: string) => string;
    value?: string;
    onChange?: (ev: any) => void;
    autoFocus?: boolean;
    buttonLabel: string;
    handleButtonClick: () => void;
};

const FormikInputWithButton: React.FC<Props & FieldProps<any>> = ({
    field,
    form,
    mapNameToLabel,
    handleButtonClick,
    ...props
}) => {
    const status =
        (form.errors[field.name] && 'error') ||
        // (form.touched[field.name] && 'success') ||
        undefined;

    return (
        <FormInputWithButton
            {...field}
            {...props}
            status={status}
            label={mapNameToLabel(field.name)}
            placeholder={mapNameToLabel(field.name)}
            error={form.errors[field.name]}
            onButtonClick={handleButtonClick}
        />
    );
};

export default FormikInputWithButton;
